module.exports = __webpack_public_path__ + "img/20220401_one_year_airdrop.eb48d28d.png";